import { ERestoreEntityType } from '@/enum';
import { IAddStudentPayload } from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getStudentList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(http.get(`/school/student?${queryString}`), false);
};

export const getStudentDetail = async (studentId: string) => {
  return serviceHelper(http.get(`/school/student/${studentId}`), false);
};

export const removeStudent = async (id: string) => {
  return serviceHelper(
    http.delete(
      `/school/restore/${id}?record_type=${ERestoreEntityType.STUDENT}`
    ),
    true
  );
};

export const addStudent = async (payload: IAddStudentPayload) => {
  return serviceHelper(http.post('/school/student', payload), true);
};

export const bulkUploadStudents = async (formData: FormData) => {
  return serviceHelper(
    http.post('/school/student/bulk-upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
    true
  );
};

export const getTeacherClassStudentDetail = async (
  classId: string,
  studentId: string
) => {
  return serviceHelper(
    http.get(`/teacher/class/${classId}/students/${studentId}`),
    false
  );
};
